export default {
    carregando: false,
    items: [],
    selecionado: {},
    visaoMacrofase: [],
    indicadorBacklog: []
}